<div class="modal" [class.is-active]="show">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <span class="icon"><i class="fa fa-dna"></i></span>
        Filter seeds from VCF-File
      </p>
      <button (click)="close()" class="delete" aria-label="close"></button>
    </header>
    <section class="modal-card-body">
      <div class="notification is-success" *ngIf="addedCount > 0">
        {{addedCount}} genes have been added to the selection.
        <div *ngIf="itemsFound.length > addedCount">
          {{itemsFound.length - addedCount}} genes have already been selected before.
        </div>
      </div>
      <div class="notification is-warning" *ngIf="itemsFound.length > 0 && addedCount === 0">
        <div *ngIf="itemsFound.length > addedCount">
          {{itemsFound.length - addedCount}} genes have already been selected before.
        </div>
      </div>
      <div class="notification is-danger" *ngIf="notFound.length > 0">
        The following {{notFound.length}} items could not be found and have been ignored:
        <ul><li class="not-found" *ngFor="let nf of notFound">{{nf}}</li></ul>
      </div>
      <div class="form-group">
        <div class="field">
          <label class="label" for="threshold">Threshold (<a target="_blank" href="https://ionreporter.thermofisher.com/ionreporter/help/GUID-57A60D00-0654-4F80-A8F9-F6B6A48D0278.html" > PolyPhen-2 probability </a>)</label>
          <div class="control">
            <input [ngModel]="threshold"
                   (ngModelChange)="handleThresholdInput($event)"
                   id="threshold"
                   class="input"
                   type="number"
                   min="0"
                   max="1"
                   step="0.01"
                   placeholder="Threshold" required>
          </div>
        </div>
        <div class="field">
          <label for="file">Choose a file (VCF 4.1, 4.2) like this <a href="assets/vcf-example-file.vcf" download>example file</a></label>
          <div class="control">
            <input type="file"
                   id="file"
                   (change)="handleFileInput($event)" required>
          </div>
        </div>
      </div>
      <div clas="field">
        <p>Note: Interpreting large files of multiple MB takes up to 30 min. It will continue after closing
          this dialogue, but do not close or refresh the window.
        </p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button (click)="loadSeeds();" class="button is-success   has-tooltip"
              data-tooltip="Add seeds from VCF-File to selection."
              [disabled]="fileContent === null || loading">
        <span class="icon">
          <i class="fas fa-plus"></i>
        </span>
        <span>
          Add seeds
        </span>
      </button>
      <button (click)="close()" class="button has-tooltip" data-tooltip="Close the current window.">
        Close
      </button>
    </footer>
  </div>
</div>



